import React from 'react';
import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import { Tooltip } from 'framework/ui/mui-builder';

interface ExternalResource {
  value: string;
  config: {
    displayName: string;
    Icon: React.ComponentType;
  };
}

interface ProjectExternalResourcesProps {
  resources: ExternalResource[];
}

const ProjectExternalResources: React.FC<ProjectExternalResourcesProps> = ({ resources }) => {
  if (!Array.isArray(resources) || resources.length === 0) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        gap: 2,
        overflow: 'hidden',
        position: 'relative',
        zIndex: 1,
      }}
    >
      {resources.map(({ value, config }) => (
        <Tooltip key={value} title={config.displayName}>
          <Link to={value} target="_blank" rel="noopener noreferrer">
            <config.Icon />
          </Link>
        </Tooltip>
      ))}
    </Box>
  );
};

export default ProjectExternalResources;
